<template>
    <div class="pure-trading-pure" :class="$t('InsitutionService.box-name')">
        <page-navigate></page-navigate>
        <div class="tech-t-sub1 tech-technology0">
            <h1 class="p1">{{ $t('PureTradingPure.screen1.line4') }}</h1>
            <p class="line"></p>
            <p class="p2" v-html="$t('PureTradingPure.screen0.subTitle')"></p>
            <div class="m-box">
                <ul>
                    <li>
                        <img src="../assets/image/PureTradingPure/technology-star.svg" alt="">
                        <p>{{ $t('PureTradingPure.screen1.line1') }}</p>
                        <span>20ms</span>
                    </li>
                    <li>
                        <img src="../assets/image/PureTradingPure/technology-star.svg" alt="">
                        <p>{{ $t('PureTradingPure.screen1.line2') }}</p>
                        <span>98.75%</span>
                    </li>
                    <li>
                        <img src="../assets/image/PureTradingPure/technology-star.svg" alt="">
                        <p>{{ $t('PureTradingPure.screen1.line3') }}</p>
                        <span>100Mbps</span>
                    </li>
                </ul>
            </div>
            <a href="https://client.myebc.co/signup-c/?bid=5s71xp"
                class="btn">{{ $t('InsitutionService.public-btn-text') }}</a>
        </div>

        <div class="tech-technology1">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <p>{{ $t('PureTradingPure.screen1.line1') }} </p><br><span>20ms</span>
                    </div>
                    <div class="col-md-4">
                        <p>{{ $t('PureTradingPure.screen1.line2') }} </p><br><span>98.75%</span>
                    </div>
                    <div class="col-md-4">
                        <p v-html="$t('PureTradingPure.screen1.line3')"></p><br><span>100Mbps</span>
                    </div>
                </div>
            </div>
        </div>


        <div class="tech-technology-ash tech-technology2">
            <div class="container">
                <p class="tech-public-title">{{ $t('PureTradingPure.screen2.title') }}</p>
                <p class="tech-public-line"></p>
                <p class="public-desc">{{ $t('PureTradingPure.screen2.desc') }}</p>
                <div class="row">
                    <img src="../assets/image/PureTradingPure/technology-01.png" alt="">
                </div>
            </div>
        </div>

        <div class="tech-technology-white tech-technology3">
            <div class="container">
                <p class="tech-public-title">{{ $t('PureTradingPure.screen7.pageTitle') }}</p>
                <p class="tech-public-line"></p>
                <p class="public-desc">{{ $t('PureTradingPure.screen7.title') }}</p>
                <div class="row">
                    <img
                        :src="require(`../assets/image/PureTradingPure/group23-${$t('PureTradingPure.screen7.imgUrl')}.png`)" />
                </div>
            </div>
        </div>

        <div class="tech-technology-ash tech-technology4">
            <div class="container">
                <p class="tech-public-title" v-html="$t('PureTradingPure.screen4.title')"></p>
                <p class="base-text">POSSIBILITY</p>
                <p class="tech-public-line"></p>
                <p class="public-desc">{{ $t('PureTradingPure.screen3.desc') }}</p>
                <div class="row">
                    <div class="col-md-7">
                        <p class="desc">{{ $t('PureTradingPure.screen3.desc') }}</p>
                        <a class="public-link2 pc-link"
                            href="https://client.myebc.co/signup-c/?bid=5s71xp">{{ $t('InsitutionService.public-btn-text') }}<img
                                class="arrow1" src="../assets/image/PureTradingPure/public-link-arrow.png" alt=""><img
                                class="arrow2" src="../assets/image/PureTradingPure/fca12.png" alt=""></a>
                    </div>
                    <div class="col-md-5 div-img">
                        <img src="../assets/image/PureTradingPure/invalidName@2x-2.png" alt="">
                    </div>
                </div>
                <a class="public-link2 m-link"
                    href="https://client.myebc.co/signup-c/?bid=5s71xp">{{ $t('InsitutionService.public-btn-text') }}<img
                        class="arrow1" src="../assets/image/PureTradingPure/public-link-arrow.png" alt=""><img
                        class="arrow2" src="../assets/image/PureTradingPure/fca12.png" alt=""></a>
            </div>
        </div>

        <div class="tech-technology-white tech-technology5">
            <div class="container">
                <p class="tech-public-title">{{ $t('PureTradingPure.screen5.title') }}</p>
                <p class="tech-public-line"></p>
                <p class="public-desc">{{ $t('PureTradingPure.screen5.desc') }}</p>
                <div class="row">
                    <div class="col-md-4 bg-red">
                        <img class="icon" src="../assets/image/PureTradingPure/group17@2x.bc6e888.png" alt="">
                        <div class="text">
                            <p v-for="(item, index) in $t('PureTradingPure.screen5.list')" :key="index">{{ item }}</p>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <img class="right-img bg-red" src="../assets/image/PureTradingPure/technology-02.png" alt="">
                    </div>
                </div>
            </div>
        </div>


        <div class="tech-technology-ash tech-page-screen-1  tech-technology5" data-v-2bf02733="">
            <div class="container" data-v-2bf02733="">
                <p class="tech-public-title">{{ $t('InsitutionService.screen1.title') }}</p>
                <p class="tech-public-line"></p>
                <c-products></c-products>
            </div>
            <router-link class="public-link2" to="/AllProducts">{{ $t('Dividend.public-btn-text2') }}<img class="arrow1"
                    src="../assets/image/TradingAccount/public-link-arrow.png" alt=""><img class="arrow2"
                    src="../assets/image/TradingAccount/fca12.png" alt=""></router-link>
        </div>


        <div class="tech-technology-white tech-technology6">
            <div class="container">
                <p class="tech-public-title">{{ $t('PureTradingPure.screen9.title') }}</p>
                <p class="tech-public-line"></p>
                <p class="tech-public-title2">{{ $t('PureTradingPure.screen9.smallTitle') }}</p>
                <p class="public-desc">{{ $t('PureTradingPure.screen9.desc') }}</p>
                <div class="row">
                    <img :src="require(`../assets/image/PureTradingPure/group25@2x-${$t('PureTradingPure.screen9.imgUrl')}.png`)"
                        alt="">
                    <div class="a-box">
                        <a :href="'https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/EBC-PRODUCT-GUIDEpdf_' + $t('CFooters.pdfLang') + '.pdf'"
                            target="_blank">{{ $t('PureTradingPure.screen5.link1') }}<img class="link-icon"
                                src="../assets/image/PureTradingPure/fca12.png" alt=""></a></a>
                        <router-link to="/AllProducts">{{ $t('PureTradingPure.screen5.link2') }}<img class="link-icon"
                                src="../assets/image/PureTradingPure/fca12.png" alt=""></router-link>
                    </div>

                    <p class="public-desc">{{ $t('PureTradingPure.screen10.desc') }}</p>

                    <img v-if="$t('common.lang') == 'jp'" src="../assets/image/technology/table.png"
                        class="black-box-img2" alt="">
                    <img v-else src="../assets/image/PureTradingPure/group26@2x.png" class="black-box-img2" alt="">
                    <div class="p-box">
                        <p class="pl"><img src="../assets/image/PureTradingPure/technology-star2.svg"
                                alt="">{{ $t('PureTradingPure.screen10.list[0]') }}</p>
                        <p class="pr"><img src="../assets/image/PureTradingPure/technology-star2.svg"
                                alt="">{{ $t('PureTradingPure.screen10.list[1]') }}</p>
                        <p class="pl"><img src="../assets/image/PureTradingPure/technology-star2.svg"
                                alt="">{{ $t('PureTradingPure.screen10.list[2]') }}</p>
                        <p class="pr"><img src="../assets/image/PureTradingPure/technology-star2.svg"
                                alt="">{{ $t('PureTradingPure.screen10.list[3]') }}</p>
                    </div>
                    <p class="tech-public-title2 tech-public-title22">{{ $t('PureTradingPure.screen10.title') }}</p>
                </div>
                <a class="public-link2"
                    href="https://client.myebc.co/signup-c/?bid=5s71xp">{{ $t('InsitutionService.public-btn-text') }}<img
                        class="arrow1" src="../assets/image/PureTradingPure/public-link-arrow.png" alt=""><img
                        class="arrow2" src="../assets/image/PureTradingPure/fca12.png" alt=""></a>
            </div>
        </div>


        <page-slogan></page-slogan>
        <ss-contact-us-new mode="all"></ss-contact-us-new>
        <!-- 
              <ss-contact-us mode="all"></ss-contact-us> -->
        <page-footer></page-footer>
    </div>
</template>

<script>
import WOW from 'wowjs';
export default {
    data() {
        return {
            loginUrl: 'https://client.ebccrm.com/',
            seoInfo: ""
        }
    },
    metaInfo() {
        return {
            title: this.seoInfo.title || '',
            meta: [ // set meta
                {
                    name: 'keyWords',
                    content: this.seoInfo.keyWords || ''
                },
                {
                    name: 'description',
                    content: this.seoInfo.description || ''
                }
            ]
        }
    },
    created() {
        this.$getSeoInfo({
            lang: this.$t("common.requestLang"),//this.$store.state.Lan,
            path: "/technology"
        }).then(res => {
            this.seoInfo = res
        })
        let lang = localStorage.getItem('language')
        let parms;
        if (lang === 'ct') {
            parms = 'tw'
        } else if (lang === 'ja') {
            parms = 'jp'
        } else if (lang === 'vi') {
            parms = 'zh'
        } else {
            parms = lang
        }
        this.loginUrl = this.loginUrl + '?hl=' + parms
    },
    mounted() {
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: false
        });
        wow.init();
    },
    methods: {
        formatter: function (num) {
            return num.toFixed(2)
        },
    }
}
</script>

<style>
@charset "UTF-8";

.c-footer .fp-overflow {
    display: unset !important;
}

.tech-t-sub1 {
    background: url(../assets/image/PureTradingPure/technology-bg.jpg) 100%/auto 100% no-repeat;
    height: 660px;
    margin-top: 0px;
    text-align: center;
    padding-top: 200px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}

.tech-t-sub1 img {
    margin-top: 26px;
    width: 330px;
    margin-bottom: 14px;
}

.tech-t-sub1 .p1 {
    color: #FFF;
    text-align: center;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    margin-top: 19px;
    letter-spacing: 2px;
}

.line {
    width: 80px;
    border: 1px solid #D9D9D9;
    margin: 50px auto 50px;
}

.tech-t-sub1 .p2 {
    color: #FFF;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 1px;
    width: 710px;
    margin: 0 auto;
    line-height: 36px;
    opacity: 0.9;
}

.tech-t-sub1 .btn {
    display: block;
    width: max-content;
    padding: 10px 56px;
    height: 46px;
    font-size: 16px;
    border-radius: 2px;
    background: #3D0101;
    color: #AF8147;
    margin: 40px auto;
}

.tech-t-sub1 .btn:hover {
    color: #3D0101;
    background: #AF8147;
}

.tech-public-title {
    color: #000000;
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: 2px;
}

.tech-public-line {
    width: 70px;
    border: 1px solid #AF8147;
    margin: 46px auto 36px;
}

.tech-public-title2 {
    color: #000000;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
}

.public-desc {
    width: 54%;
    color: #666666;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    margin: 20px auto 0;
}


.tech-t-sub2 {
    background: #F8F8F8;
    padding: 80px 0;
}

.tech-t-sub2 .row {
    background: linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%);
    margin: 46px auto;
    padding: 50px 10% 50px 17%;
    width: 1000px;
}

.tech-t-sub2 .row div {
    margin-top: 10px;
}

.tech-t-sub2 .row img {
    width: 30px;
    position: relative;
    top: 7px;
}

.tech-t-sub2 .row p {
    color: #080E1C;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 1px;
    display: inline;
    line-height: 46px;
    margin-left: 16px;
}


.public-btn {
    display: block;
    width: max-content;
    padding: 13px 40px;
    height: 44px;
    font-size: 16px;
    border-radius: 2px;
    color: #3D0101;
    margin: 50px auto 0px;
    text-align: center;
    border: 1px solid #3D0101;
    border-radius: 2px;
}

.public-btn:hover {
    color: #3D0101;
    background: #AF8147;
    border: 1px solid #AF8147;
}

.btn-box {
    width: max-content;
    margin: auto;
}


.tech-t-sub3 {
    background: #ffffff;
    padding: 90px 0 160px;
}

.tech-t-sub3 .row {
    margin: 54px auto;
    width: 1200px;
}

.tech-t-sub3 .row div {
    text-align: center;
}

.tech-t-sub3 .row img {
    width: 65px;
    position: relative;
    top: 26px;
}

.tech-t-sub3 .row img {
    width: 90px;
}

.tech-t-sub3 .row .title {
    color: #080E1C;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 48px;
    margin-top: 22px;
}

.tech-t-sub3 .row .desc {
    color: #080E1C;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 28px;
    padding: 0 10%;
}


.tech-t-sub4 {
    background: #F8F8F8;
    padding: 80px 0;
}

.tech-t-sub4 img {
    display: block;
    margin: 40px auto;
    width: 60%;
    background: #fff;
    padding: 30px;
}

.tech-t-sub4 .public-desc {
    width: 60%;
    text-align: left;
}


.tech-t-sub5 {
    background: #FFFFFF;
    padding: 80px 0;
}

.tech-t-sub5 .tech-t-sub5-img {
    display: block;
    margin: 40px auto;
    width: 1000px;
}

.tech-t-sub5 .public-desc {
    width: 500px;
}

.tech-t-sub5-content {
    position: relative;
    width: 1000px;
    margin: 0 auto;
}

.tech-t-sub5-bottom {
    position: absolute;
    bottom: 0px;
    height: 80px;
    background: rgba(29, 1, 1, 0.75);
    width: 1000px;
    text-align: center;
}

.tech-t-sub5-bottom p {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: 1px;
    display: inline;
    padding: 0 60px;
    line-height: 74px;
}

.tech-t-sub5-bottom img {
    width: 7px;
    margin-left: 10px;
}

.tech-t-sub5-bottom span {
    font-size: 26px;
    font-weight: bold;
}

.public-slogan {
    padding: 28px 0px;
    background: #F8F8F8;
    color: #3D0101;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
    font-weight: 600;
}

.tech-t-subtner-box-en .tech-t-sub2 .row {
    padding: 50px 0% 26px 22%;
}

.tech-t-subtner-box-en .tech-t-sub2 .row div {
    width: 100%;
}

.tech-t-subtner-box-en .tech-t-sub1 .p1 {
    line-height: 52px;
    margin-top: 60px;
}

.tech-t-subtner-box-en .public-desc {
    width: 750px;
}

.tech-t-subtner-box-en .tech-t-sub3 .row p {
    margin-left: 10px;
    display: block;
    line-height: 26px;
    margin-top: 30px;
}

.tech-t-subtner-box-en .tech-t-sub1 .p2 {
    letter-spacing: 0px;
    width: 718px;
    line-height: 30px;
}

.tech-t-subtner-box-en .tech-t-sub2 .row p {
    letter-spacing: 0px;
}

.tech-t-sub1 .btn-ug {
    width: 190px;
}


.tech-t-sub5 .container {
    max-width: 1100px;
}

.tech-t-sub5 .row div {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 40px;
}

.tech-t-sub5 .row img {
    width: 80%;
}

.tech-t-sub5 .row p {
    color: #666666;
    font-size: 16px;
    line-height: 26px;
    width: 90%;
    margin: 30px auto 0;
}

.tech-t-sub6 {
    background: #F8F8F8;
    padding: 80px 0;
}

.tech-t-sub6 .container {
    max-width: 1100px;
}

.tech-t-sub6 .row div {
    background: #fff;
    width: auto;
    margin: 10px 2% 20px;
    height: 44px;
    padding: 14px 20px 14px 46px;
    position: relative;
    border-radius: 3px;
}

.tech-t-sub6 .row div img {
    width: 18px;
    position: absolute;
    top: 13px;
    left: 20px;
}

.tech-t-sub6 .row div p {
    float: left;
    font-size: 16px;
}

.tech-t-sub1 .p1 br {
    display: none;
}

.en-style .tech-t-sub1 .p2 {
    letter-spacing: 0px;
}

.en-style .tech-t-sub1 .p1 {
    margin-top: 80px;
}

.vi-box .tech-t-sub1 .p1 {
    margin-top: 40px;
}




.public-link {
    background: #3d0101;
    /* padding: 11px 28px; */
    color: #fff;
    font-size: 16px;
    letter-spacing: 1px;
    display: block;
    width: max-content;
    padding: 15px 29px;
    float: left;
    margin-top: 20px;
}

.public-link img {
    width: 7px;
    margin-left: 12px;
}

.public-link:hover {
    color: #ffffff;
    background: #AF8147;
}

.public-link2 {
    padding: 14px 28px;
    color: #3d0101;
    font-size: 16px;
    border: 1px solid #3d0101;
    margin-right: 12px;
    letter-spacing: 1px;
    display: block;
    width: max-content;
    float: left;
    margin-top: 20px;
}

.public-link2 img {
    width: 7px;
    margin-left: 12px;
}

.public-link2:hover {
    color: #ffffff;
    background: #3d0101;
    border: 1px solid #3d0101;
}

.arrow2 {
    display: none !important;
}

.public-link2:hover .arrow1 {
    display: none !important;
}

.public-link2:hover .arrow2 {
    display: inline-block !important;
}


.product {
    width: 1000px;
    margin: 50px auto;
}

.product .accordion-header {
    cursor: pointer
}

.product .table-list {
    width: 100%;
    border: none;
    position: relative;
    flex-direction: inherit;
    background: #949699;
}

.product .table-list .flex-1 {
    font-weight: 700;
    line-height: 40px;
    color: #ffffff;
    font-size: 14px;
    padding: 2px 12px;
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
    cursor: pointer;
    font-family: auto;
    text-align: center;
}

.product .table-list .flex-1.active {
    background-color: #3D0101;
    color: #ffffff;
}

.product-box__nav {
    /* margin-bottom: 4px; */
    font-size: 14px;
    font-weight: 700;
    line-height: 40px;
    color: #666666;
    padding: 0 12px;
    background-color: #F8F8F8;
    padding: 4px 0;
}

.product-box__nav div {
    line-height: 40px;
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: auto;
    text-align: center;
}

.product-box__accordion-item {
    background: #f7f7f7;
    border: none
}

.product-box__accordion-item .accordion-button {
    padding: 10px;
    font-size: 14px;
    background: #ffffff;
    color: #333
}

.product-box__accordion-item .accordion-body-head {
    width: 100%;
    padding: 12px 0;
    background-color: #949699;
    color: #f7f7f7
}

.product-box__accordion-item .accordion-body-head div {
    flex: 1
}

.product-box__accordion-header {
    margin-bottom: 0
}

.product-box .accordion-body-tr {
    width: 100%;
    padding: 12px 0;
    font-family: auto;
}

.product-box .accordion-body-tr div {
    flex: 1;
    text-align: center;
}

.product-box .accordion-body-tr div:nth-of-type(2) {
    color: #48ba13
}

.product-box .accordion-body-tr .red {
    color: #cc3221 !important
}

.product-box .accordion-body-tr div:nth-of-type(5) {
    color: #48ba13
}

.product .look-all {
    display: flex;
    justify-content: center;
    color: #8b8b8b;
    padding: 20px 0;
    font-size: 16px;
    margin-top: 30px;
}

.product .look-all span {
    padding-top: 5px;
    border-top: 1px solid #8b8b8b
}

.product .c-underline__top:after {
    /* background: #7d1614;
    height: 4px */
}

.accordion-body {
    font-size: 14px;
    font-family: auto;
    background: #f8f8f8;
}




.rotate .accordion-button:after {
    transform: rotate(180deg);
}



.en-style2 .tech-t-sub1 .p2 {
    letter-spacing: 0px;
}

.en-style2 .tech-t-sub3 .row .title {
    letter-spacing: 0px;
    line-height: 26px;
    margin-top: 32px;
    margin-bottom: 14px;
}

.en-style2 .tech-t-sub3 .row .desc {
    letter-spacing: 0px;
}

.en-style2 .public-link2 {
    letter-spacing: 0px;
}

.en-style2 .public-link {
    letter-spacing: 0px;
}

.account1 {
    padding: 80px 0 170px;
    background: #f8f8f8;
}

.account1 .container {
    width: 950px;
    text-align: center;
}

.account1 .row .title {
    font-size: 28px;
    color: #080E1C;
    font-weight: 700;
    margin-bottom: 30px;
    letter-spacing: 1px;
}

.account1 .row .title2 {
    color: #3D0101;
}

.account1 .row .desc1,
.account1 .row .desc2,
.account1 .row .desc3 {
    font-size: 17px;
    line-height: 50px;
    letter-spacing: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.account1 .row .div1 {
    margin-top: 60px;
}

.account1 .row .desc1 {
    color: #949699;
}

.account1 .row .desc2 {
    color: #080E1C;
}

.account1 .row .desc3 {
    color: #3D0101;
}

.account1 .public-link2 {
    margin-right: 0px;
    margin-top: 40px;
}

.tech-technology-ash {
    padding: 100px 0 80px;
    background: #f8f8f8;
}

.tech-technology-ash .row img {
    width: 80%;
    margin: 40px auto 40px;
}

.tech-technology-ash .public-desc {
    color: #949699;
    font-size: 18px;
}

.tech-technology-ash .public-link2 {
    float: unset;
    margin: 0 auto;
}

.tech-technology-white {
    padding: 100px 0 80px;
}

.tech-technology-white .row img {
    width: 80%;
    margin: 40px auto 40px;
}

.tech-technology-white .public-desc {
    color: #949699;
    font-size: 18px;
}

.tech-technology-white .public-link2 {
    float: unset;
    margin: 0 auto;
}

.en-style2 .tech-t-sub1 .p2 {
    letter-spacing: 0px;
}

.en-style2 .account1 .row .desc1,
.en-style2 .account1 .row .desc2,
.en-style2 .account1 .row .desc3 {
    letter-spacing: 0px;
}

.en-style2 .account1 .row .title {
    letter-spacing: 0px;
    font-size: 26px;
}

.en-style2 .public-desc {
    width: 80%;
}

.en-style2 .tech-public-title {
    padding: 0 10%;
    line-height: 38px;
}

.tech-technology2 .row img {
    width: 60%;
}

.tech-technology3 .row img {
    width: 70%;
}



.tech-technology1 {
    background: #ffffff;
    padding: 32px 0 38px;
    text-align: center;
}

.tech-technology1 p {
    font-size: 18px;
    display: inline-block;
    line-height: 28px;
}

.tech-technology1 span {
    color: #7D0101;
    font-size: 30px;
    font-weight: bold;
}

.tech-technology4 .public-desc {
    display: none;
}

.tech-technology4 .tech-public-line {
    display: none;
}

.tech-technology4 {
    position: relative;
    padding-top: 120px;
    padding-bottom: 52px;
}

.tech-technology4 .base-text {
    color: #F1F1F1;
    font-size: 120px;
    letter-spacing: 1px;
    font-weight: bold;
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
}

.tech-technology4 .tech-public-title {
    z-index: 999;
    position: relative;
}

.tech-technology4 .public-link2 img {
    width: 7px;
    margin: 0;
    margin-left: 12px;
}

.tech-technology4 .desc {
    width: 90%;
    color: #999999;
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    margin: 160px 0 0;
}

.tech-technology4 .row {
    width: 900px;
    margin: 0 auto;
}

.tech-technology4 .public-link2 {
    margin: 30px 0;
}

.tech-technology4 .div-img {
    text-align: right;
}

.tech-technology4 .div-img img {
    margin-top: 100px;
}

.tech-technology5 .public-desc {
    width: 60%;
}

.tech-technology2 .public-desc {
    width: 46%;
}

.tech-technology5 .container {
    width: 1000px;
}

.tech-technology5 .bg-red {
    background: #2D0101;
}

.tech-technology5 .row {
    margin-top: 30px;
    margin-bottom: 50px;
}

.tech-technology5 .row div {
    padding: 0;
    height: 405.5px;
}

.tech-technology5 .row .icon {
    width: 50px;
    float: left;
    margin-left: 54px;
    margin-top: 68px;
}

.tech-technology5 .row .right-img {
    margin: 0;
    width: 100%;
}

.tech-technology5 .row p {
    color: #FFFFFF;
    font-size: 18px;
    display: inline-block;
    float: left;
    width: 200px;
    line-height: 72px;
    margin-left: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tech-technology5 .row .text {
    margin-top: 54px;
}

.tech-technology6 .row img {
    width: 46%;
}

.tech-technology6 .public-desc {
    width: 60%;
}

.tech-technology5 {
    /*padding-bottom: 10px;*/
}

.tech-technology6 .a-box {
    width: 960px;
    margin: 30px auto 0;
    padding: 18px 0;
    background: #3D0101;
    text-align: center;
}

.tech-technology6 .a-box a {
    font-size: 16px;
    color: #ffffff;
    margin: 0 50px;
}

.tech-technology6 .a-box .link-icon {
    width: 7px;
    margin: 0;
    margin-left: 12px;
}

.tech-technology6 .public-link2 {
    margin-top: 10px;
}

.tech-page-screen-1 {
    padding-bottom: 80px;
}

.tech-technology0 .m-box {
    display: none;
}

.tech-technology4 .m-link {
    display: none;
}

.tech-technology4 .pc-link {
    display: block;
}

.en-style2 .tech-technology2 .public-desc {
    width: 60%;
}

.en-style2 .tech-technology1 p {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.en-style2 .tech-technology5 .public-desc {
    width: 80%;
}

.en-style2 .tech-technology5 .row .icon {
    margin-left: 40px;
}

.en-style2 .tech-technology6 .public-desc {
    width: 80%;
}

.en-style2 .tech-technology4 .tech-public-title {
    line-height: 44px;
}

.en-style2 .tech-technology4 {
    padding-top: 92px;
}

.en-style2 .tech-technology4 .desc {
    margin: 120px 0 0;
}

.en-style2 .tech-technology4 .div-img img {
    margin-top: 72px;
}

.en-style2 .tech-public-title {
    letter-spacing: 0px;
}

.en-style2 .tech-t-sub1 .p1 {
    letter-spacing: 0px;
}

.tech-technology1 br {
    display: none;
}

.en-style2 .tech-technology1 br {
    display: block;
}

.tech-technology6 .a-box {
    width: 830px;
    margin-top: 0px;
    margin-bottom: 12px;
}

.tech-technology6 .a-box a {
    margin: 0 100px;
}

.tech-technology6 .public-desc {
    width: 63%;
}

.tech-technology6 .row .black-box-img2 {
    width: 60%;
}

.tech-technology6 .p-box {
    width: 700px;
    margin: 0 auto;
}

.tech-technology6 .p-box p {
    font-size: 18px;
    position: relative;
    padding-left: 30px;
    line-height: 30px;
    float: left;
    color: #999999;
    margin-bottom: 10px;
}

.tech-technology6 .p-box .pl {
    width: 60%;
}

.tech-technology6 .p-box .pr {
    width: 40%;
}

.tech-technology6 .p-box img {
    width: 20px;
    margin: 0;
    position: absolute;
    top: 4px;
    left: 0;
}

.tech-technology6 .tech-public-title22 {
    width: 50%;
    margin: 20px auto;
    line-height: 32px;
}

.en-style2 .tech-technology6 .a-box {
    width: 960px;
}

.en-style2 .tech-technology6 .tech-public-desc {
    width: 73%;
}

.en-style2 .tech-technology6 .p-box .pl {
    width: 100%;
    text-align: center;
    padding-left: 0px;
}

.en-style2 .tech-technology6 .p-box .pr {
    width: 100%;
    text-align: center;
    padding-left: 0px;
}

.en-style2 .tech-technology6 .p-box img {
    position: relative;
    margin-right: 10px;
}

.en-style2 .tech-technology6 .tech-public-title22 {
    width: 73%;
}

.en-style2 .tech-technology6 .p-box {
    width: 100%;
}


@media(max-width:1400px) {
    .tech-t-sub1 {
        height: 520px;
        padding-top: 140px;
    }

    .tech-t-sub1 .p1 {
        font-size: 34px;
    }

    .tech-t-sub1 .p2 {
        line-height: 32px;
        font-size: 16px;
        width: 600px;
    }

    .tech-t-sub4 img {
        width: 700px;
    }

    .tech-t-sub5 .tech-t-sub5-img {
        width: 700px;
    }

    .tech-t-sub5-bottom {
        width: 700px;
        height: 68px;
    }

    .tech-t-sub5-content {
        width: 700px;
    }

    .tech-t-sub5-bottom p {
        line-height: 60px;
    }

    .tech-t-subtner-box-en .tech-t-sub1 {
        height: 650px;
    }

    .en-style2 .tech-technology1 p {
        font-size: 15px;
    }
}


@media(max-width:995px) {
    .tech-t-sub1 .p1 br {
        display: block !important;
    }

    .tech-t-sub2 .row {
        width: 90%;
        padding: 20px 0% 0px 13%;
        margin: 30px auto;
    }

    .tech-t-sub2 .row p {
        font-size: 14px;
    }

    .tech-t-sub2 .row div {
        margin-top: 0px;
    }

    .tech-t-sub3 .row {
        width: 100%;
        padding: 19px 0% 0px 0%;
        margin: 10px auto 30px;
        background: #ffffff;
    }

    .tech-t-sub3 .row div {
        width: 50%;
        margin-bottom: 30px;
    }

    .tech-t-sub3 .row img {
        width: 90px;
    }

    .public-link2 {
        padding: 14px 18px;
        margin-top: 0px;
        text-align: center;
        width: 100%;
    }

    .public-link {
        padding: 15px 19px;
        margin-top: 0px;
        width: 100%;
        text-align: center;
    }

    .tech-t-sub3 .row .title {}

    .tech-t-sub3 .row .desc {
        font-size: 15px;
        padding: 0 0%;
        line-height: 26px;
    }

    .tech-t-sub5-content {
        width: 100%;
    }

    .tech-t-sub5 .tech-t-sub5-img {
        width: 100%;
    }

    .tech-t-sub5-bottom {
        width: 100%;
        height: 46px;
    }

    .tech-t-sub5-bottom p {
        line-height: 42px;
        font-size: 14px;
        padding: 0px 20px;
    }

    .tech-t-sub5-bottom span {
        font-size: 18px;
    }

    .tech-t-sub5-bottom img {
        width: 6px;
        margin-left: 6px;
    }

    .tech-t-sub1 .p2 {
        width: 100%;
        padding: 24px 8%;
        font-size: 16px;
        line-height: 30px;
    }

    .line {
        width: 62px;
        border: 1px solid #D9D9D9;
        margin: 26px auto 0px;
    }

    .tech-t-sub1 .p1 {
        margin-top: 20px;
        line-height: 58px;
        font-size: 34px;
    }

    .tech-t-sub1 .btn {
        margin: 14px auto;
    }

    .public-desc {
        width: 90%;
        font-size: 15px;
        line-height: 24px;
    }

    .tech-t-sub4 .public-desc,
    .tech-t-sub5 .public-desc {
        width: 90%;
    }

    .tech-t-sub2,
    .tech-t-sub3,
    .tech-t-sub4,
    .tech-t-sub5 {
        padding: 56px 0;
    }

    .tech-public-line {
        width: 50px;
        margin: 40px auto 0px;
    }

    .tech-public-title {
        font-size: 26px;
    }

    .tech-t-sub2 .row img {
        width: 28px;
    }

    .tech-t-sub4 img {
        width: 90%;
    }

    .public-slogan {
        padding: 20px 20px;
        line-height: 28px;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row {
        padding: 20px 0% 0px 3%;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row div {
        width: 100%;
        margin-top: 14px;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row div p {
        line-height: 30px;
    }

    .tech-t-subtner-box-en .tech-t-sub1 .p1 {
        line-height: 44px;
        font-size: 28px;
        width: 90%;
        margin: 20px auto 0;
    }

    .tech-public-title2 {
        line-height: 26px;
    }

    .tech-t-subtner-box-en .tech-t-sub5-bottom p {
        font-size: 12px;
        letter-spacing: 0px;
        padding: 0px 8px;
    }

    .tech-t-subtner-box-en .tech-t-sub5-bottom span {
        font-size: 16px;
    }

    .tech-t-subtner-box-en .public-desc {
        width: 90%;
    }

    .tech-t-subtner-box-en .tech-t-sub1 .p2 {
        width: 100%;
        font-size: 14px;
        line-height: 26px;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row {
        width: 100%;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row img {
        width: 24px;
    }

    .tech-t-subtner-box-en .tech-t-sub1 .p1 {
        font-size: 26px;
        line-height: 34px;
    }

    .tech-t-subtner-box-en .tech-public-title {
        font-size: 22px;
        line-height: 32px;
    }

    .tech-t-subtner-box-en .public-slogan {
        padding: 16px 0px;
        line-height: 28px;
        font-size: 13px;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row div p {
        line-height: 30px;
        margin-left: 6px;
    }

    .tech-t-subtner-box-en .tech-t-sub2 .row div {
        text-align: center;
    }

    .tech-t-subtner-box-en .tech-t-sub3 .row p {
        margin-left: 8px;
        display: block;
        line-height: 18px;
        margin-top: 8px;
        font-size: 12px;
    }

    .public-slogan {
        padding: 16px 0px;
        line-height: 28px;
        font-size: 13px;
    }

    .tech-t-sub1 .p1 br {
        display: block;
    }

    .tech-t-sub4 img {
        padding: 0;
        background: none;
        margin: 0 auto;
        width: 96%;
    }

    .public-btn {
        margin: 40px auto 0px;
    }

    .tech-t-sub4 .public-desc {
        margin-top: 30px;
    }

    .tech-t-sub5 .row div {
        width: 50%;
        margin-bottom: 0px;
    }

    .tech-t-sub5 .row p {
        font-size: 14px;
        width: 82%;
        margin: 20px auto 0;
        line-height: 22px;
    }

    .tech-t-sub5 .row img {
        width: 88%;
    }

    .tech-t-sub6 .row div p {
        font-size: 14px;
    }

    .tech-t-sub6 .row div {
        margin-bottom: 6px;
        margin-left: 4%;
        padding: 16px 10px 14px 36px;
    }

    .tech-t-sub6 .row div img {
        top: 13px;
        left: 12px;
    }

    .tech-t-sub6 {
        padding-bottom: 50px;
    }

    .en-style .tech-t-sub6 .row div {
        width: 92%;
        line-height: 22px;
        height: auto;
        padding: 14px 10px 12px 36px;
    }

    .en-style .tech-t-sub6 .row div p {
        font-size: 14px;
    }

    .en-style .tech-t-sub6 .row div img {
        top: 18px;
        left: 12px;
        width: 13px;
    }

    .en-style .tech-public-title {
        font-size: 23px;
    }

    .en-style .tech-t-sub1 .p1 {
        line-height: 46px;
        font-size: 30px;
        margin-top: 55px;
    }

    .product {
        width: 100%;
    }

    .product .table-list .flex-1:nth-child(4),
    .product .table-list .flex-1:nth-child(5) {
        display: none;
    }

    .accordion-body {
        padding: 0;
    }

    .product-box__nav {
        font-size: 12px;
    }

    .product-box__accordion-item .accordion-button {
        font-size: 12px;
    }

    .accordion-body {
        font-size: 12px;
    }

    .product .table-list .flex-1 {
        font-size: 13px;
    }

    .product .accordion-button:after {
        display: none;
    }

    .product-box__accordion-item .accordion-button {
        padding: 8px 0;
    }

    .en-style2 .public-link2 {
        float: unset;
        margin-bottom: 16px;
    }

    .en-style2 .public-link {
        float: unset;
    }

    .en-style2 .tech-t-sub3 .row .title {
        line-height: 24px;
    }

    .en-style2 .tech-t-sub3 .row .desc {
        margin-top: 14px;
    }

    .en-style2 .product {
        margin-top: 30px;
    }

    .en-style2 .tech-public-title {
        padding: 0 8%;
        line-height: 32px;
    }

    .en-style2 .product {
        margin-bottom: 30px;
    }

    .tech-t-sub1 .btn {
        display: block;
        margin-top: 36px;
    }

    .tech-t-sub1 {
        background: url(../assets/image/PureTradingPure/technology-bg-m.jpg) 100%/auto 100% no-repeat;
        height: 860px;
        margin-top: 0px;
        text-align: center;
        padding-top: 100px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
    }

    .tech-t-sub1 .p1 {
        font-size: 27px;
    }

    .account1 {
        padding: 50px 2% 50px;
        background: #ffffff;
    }

    .account1 .container {
        width: 100%;
    }

    .account1 .row div {
        width: 33.3%;
    }

    .account1 .row .title {
        font-size: 17px;
        letter-spacing: 0px;
        white-space: nowrap;
        max-width: 110px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 20px;
    }

    .account1 .row .desc1,
    .account1 .row .desc2,
    .account1 .row .desc3 {
        font-size: 14px;
        line-height: 20px;
        margin-top: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0px;
    }

    .account1 .row .div1 {
        margin-top: 22px;
        text-align: right;
    }

    .account1 .btn-box {
        display: none;
    }

    .tech-t-sub3 {
        background: #f8f8f8;
    }

    .tech-t-sub3 .row {
        background: #f8f8f8;
    }

    .tech-t-sub3 .row div {
        width: 100%;
    }

    .public-link,
    .public-link2 {
        width: 70%;
        text-align: center;
        margin: 20px auto 10px;
        float: unset;
    }

    .btn-box {
        width: 100%;
    }

    .tech-technology-ash {
        background: #ffffff;
        padding: 60px 3%;
    }

    .tech-technology-ash .public-desc {
        width: 100% !important;
        font-size: 16px;
        line-height: 24px;
    }

    .tech-technology-ash .row img {
        width: 100%;
        margin: 20px auto 30px;
    }

    .tech-technology-white {
        padding: 60px 3%;
        background: #f8f8f8;
    }

    .tech-technology-white .public-desc {
        width: 100% !important;
        font-size: 16px;
        line-height: 24px;
    }

    .tech-technology-white .row img {
        width: 100%;
    }

    .tech-public-line {
        margin: 30px auto 30px;
    }

    .tech-t-sub3 .tech-public-line {
        margin-bottom: 0px;
    }

    .en-style2 .tech-t-sub1 .p2 {
        padding-top: 14px;
    }

    .en-style2 .account1 .row .title {
        font-size: 16px;
    }

    .en-style2 .tech-public-title {
        font-size: 24px;
    }

    .en-style2 .tech-t-sub3 .row .desc {
        padding: 0 10%;
    }

    .tech-t-sub1 img {
        width: 16px;
        margin: 0;
    }

    .tech-technology0 .m-box li {
        width: 70%;
        margin: 8px auto;
        border-radius: 2px;
        background: rgba(0, 0, 0, 0.59);
        padding: 20px 0;
    }

    .tech-technology0 .m-box li p {
        font-size: 16px;
        color: #ffffff;
        margin: 8px 0;
    }

    .tech-technology0 .m-box li span {
        font-size: 24px;
        color: #ffffff;
        font-weight: bold;
    }

    .tech-technology0 .m-box {
        display: block;
    }

    .tech-technology1 {
        display: none;
    }

    .tech-t-sub1 .p2 br {
        display: none;
    }

    .tech-technology4 .row {
        width: 100%;
    }

    .tech-technology4 .tech-public-title {
        padding: 0 10%;
        line-height: 38px;
    }

    .tech-technology4 .base-text {
        display: none;
    }

    .tech-technology4 .tech-public-line {
        display: block;
    }

    .tech-technology4 .public-link2 img {
        width: 7px;
        margin: 0;
        margin-left: 12px;
    }

    .tech-technology4 .desc {
        width: 100%;
        color: #949699;
        font-weight: 400;
        margin: 0;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
    }

    .tech-technology4 .public-link2 {
        margin: 30px auto;
    }

    .tech-technology4 .pc-link {
        display: none;
    }

    .tech-technology4 .m-link {
        display: block;
    }

    .tech-technology4 .div-img {
        text-align: center;
    }

    .tech-technology4 .div-img img {
        width: 60%;
        margin-top: 30px;
        margin-bottom: 0px;
    }

    .tech-technology5 .container {
        width: 100%;
    }

    .tech-technology5 {
        padding-left: 0;
        padding-right: 0;
    }

    .tech-technology5 .row div {
        height: auto;
    }

    .tech-technology5 .row .icon {
        width: 50px;
        float: left;
        margin-left: 22%;
        margin-top: 40px;
    }

    .tech-technology5 .row .text {
        margin-top: 27px;
    }

    .tech-technology5 .row {
        margin-bottom: 30px;
    }

    .tech-page-screen-1 {
        padding-bottom: 60px;
    }

    .tech-technology6 .a-box {
        padding: 15px 0;
    }

    .tech-technology6 .a-box a {
        font-size: 15px;
        margin: 0 4%;
    }

    .en-style2 .tech-t-sub1 .p1 {
        line-height: 34px;
        padding: 0 9%;
    }

    .en-style2 .tech-technology0 .m-box li {
        width: 78%;
    }

    .en-style2 .tech-technology4 .tech-public-title {
        padding: 0 6%;
    }

    .en-style2 .tech-technology5 .row .icon {
        margin-left: 20%;
    }

    .en-style2 .tech-technology6 .a-box a {
        display: block;
        margin-bottom: 14px;
    }

    .en-style2 .tech-technology6 .a-box {
        padding: 18px 0 3px;
    }

    .tech-technology6 {
        padding-bottom: 30px;
    }

    .en-style2 .tech-t-sub1 .p1 {
        font-size: 26px;
        padding: 0 4%;
    }

    .en-style2 .tech-technology0 .m-box li p {
        font-size: 14px;
        line-height: 20px;
    }

    .en-style2 .tech-technology0 .m-box li {
        width: 80%;
        padding: 20px 3px;
    }

    .en-style2 .tech-t-sub1 .p2 {
        padding: 24px 4%;
    }

    .en-style2 .tech-t-sub1 {
        height: 880px;
    }

    .en-style2 .tech-public-title {
        padding: 0;
    }

    .en-style2 .tech-technology4 .tech-public-title {
        line-height: 32px;
        padding: 0;
    }

    .en-style2 .tech-technology4 {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    .en-style2 .tech-technology4 .desc {
        margin-top: 0px;
    }

    .en-style2 .tech-technology5 .row .icon {
        margin-left: 19%;
    }

    .en-style2 .public-link2 {
        padding: 14px 9%;
        width: max-content;
    }

    .tech-technology6 .p-box img {
        width: 20px;
        position: relative;
        margin-right: 7px;
    }

    .tech-technology6 .row .black-box-img2 {
        margin: 20px auto;
    }

    .tech-technology6 .p-box .pl,
    .tech-technology6 .p-box .pr {
        width: 100%;
        padding-left: 0px;
        text-align: center;
    }

    .tech-technology6 .row .black-box-img2 {
        width: 100%;
    }

    .tech-technology6 .p-box p {
        font-size: 16px;
    }

    .tech-technology6 .tech-public-title22 {
        width: 94%;
        line-height: 26px;
    }

    .en-style2 .tech-technology6 .tech-public-title22 {
        width: 94%;
    }

    .en-style2 .tech-technology6 .p-box .pl,
    .en-style2 .tech-technology6 .p-box .pr {
        line-height: 24px;
    }
}

@media(max-width:400px) {
    .tech-t-sub6 .row div p {
        font-size: 13px;
    }

    .tech-t-sub6 .row div {
        margin-bottom: 6px;
        margin-left: 4%;
        padding: 14px 10px 12px 34px;
        height: 38px;
    }

    .tech-t-sub6 .row div img {
        top: 13px;
        left: 12px;
        width: 14px;
    }

    .en-style .tech-t-sub6 .row div {
        width: 92%;
        line-height: 22px;
        height: auto;
    }

    .en-style .tech-t-sub6 .row div p {
        font-size: 14px;
    }

    .account1 .row .title {
        font-size: 16px;
    }
}

@media(max-width:390px) {

    .account1 .row .desc1,
    .account1 .row .desc2,
    .account1 .row .desc3 {
        font-size: 13px;
    }
}
</style>
